export enum ProfileSections {
  None = 0,
  AboutMe = 1 << 0, // 1
  Projects = 1 << 1, // 2
  Education = 1 << 2, // 4
  Certifications = 1 << 3, // 8
  Skills = 1 << 4, // 16
  PrimaryCapability = 1 << 5, // 32
  Industries = 1 << 6, // 64
  Confidentiality = 1 << 7, // 128
}

const presentationValues = new Map<ProfileSections, { description: string }>([
  [ProfileSections.None, { description: "None" }],
  [ProfileSections.AboutMe, { description: "Profile Summary" }],
  [ProfileSections.Projects, { description: "Projects" }],
  [ProfileSections.Education, { description: "Education" }],
  [ProfileSections.Certifications, { description: "Certifications" }],
  [ProfileSections.Skills, { description: "Skills" }],
  [ProfileSections.PrimaryCapability, { description: "Primary Capability" }],
  [ProfileSections.Industries, { description: "Industries" }],
  [ProfileSections.Confidentiality, { description: "Confidentiality" }],
]);

export function profileSectionsToString(
  profileSections: ProfileSections,
): string {
  return presentationValues.get(profileSections)?.description ?? "None";
}
